import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

import { FullAddressPipe } from '@commons/pipes/full-address.pipe';
import { MapService } from '@commons/services/map/map/map.service';
import { LanguageService } from '@shared/services/language.service';
import { BusinessEvent } from '@commons/models/domain/BusinessEvent';
import { Consts } from '@commons/consts/consts';
import { EventTypeEnum } from '@commons/enums/event-type.enum';
import { Driver } from '@commons/models/domain/Driver';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { TranslateService } from '@ngx-translate/core';
import { NewDataStoreService } from '@shared/services/new-data-store.service';

@Component({
  selector: 'app-modal-event-information',
  templateUrl: './modal-event-information.component.html',
  styleUrls: ['./modal-event-information.component.scss'],
  providers: [FullAddressPipe],
})
export class ModalEventInformationComponent implements OnInit, OnDestroy {

  @ViewChild('container') public container: ElementRef<HTMLDivElement>;

  public isVisible: boolean;
  public formattedDate: any;
  public formattedStreet: string;
  public eventData!: BusinessEvent;
  public defaultVehicleName = this.translate.instant('events-list.unknown-vehicle');
  public defaultDriverName = this.translate.instant('events-list.unknown-driver');
  public driver?: Driver;
  public vehicle?: Vehicle;
  public valueLFuel?: number;

  public eventType: Consts;
  public eventMode: EventTypeEnum;
  
  private onChangeModalVisibleSubsc: Subscription;
  private onClickParkStopIconSubsc: Subscription;

  public readonly EVENT_TYPE_ENUM = EventTypeEnum;
  public readonly VALUE_SIGN = Consts;
  public readonly langauge: string = this.languageService.current;

  constructor(
    private mapService: MapService,
    private languageService: LanguageService,
    private translate: TranslateService,
    private newDataStoreService: NewDataStoreService,
  ) { }

  ngOnInit(): void {
    this.onChangeModalVisible();
  }

  ngOnDestroy(): void {
    this.onChangeModalVisibleSubsc?.unsubscribe();
    this.onClickParkStopIconSubsc?.unsubscribe();
  }

  public copyCords(): void {
    const coords = `${this.eventData?.EL.Lt},${this.eventData?.EL.Ln}`;
    navigator.clipboard.writeText(coords);
  }

  public onClickHideModal(): void {
    this.isVisible = false;
    this.hideModal();
  }

  private hideModal(): void {
    this.container.nativeElement.classList.add('hide');
    setTimeout(() => {
      this.container.nativeElement.classList.remove('is-visible');
    }, 150);
  }

  private showModal(): void {
    this.isVisible = true;
    this.container.nativeElement.classList.add('is-visible');
    this.container.nativeElement.classList.remove('hide');
  }

  private onChangeModalVisible(): void {
    this.onClickParkStopIconSubsc = this.mapService.onClickParkStopIcon$.subscribe((data) => {
      if (data) this.hideModal();
    });

    this.onChangeModalVisibleSubsc = this.mapService.onClickEventList$.subscribe(
      (res) => {
        if (res?.data) {
          this.eventType = res.data.EA;
          this.eventData = res.data;
          this.eventMode = res.eventMode;
          this.getVehicleData();
          if (this.eventMode === EventTypeEnum.Fuel) this.getFuelData();

          if (this.isVisible) {
            this.hideModal();
          }
          setTimeout(() => {
            this.showModal();
          }, this.isVisible ? 150 : 0);
          return;
        }
        this.hideModal();
      }
    );
  }

  private getVehicleData(): void {
    if (this.eventData?.DI) {
      const driver = this.newDataStoreService.getDriverById(this.eventData?.DI);
      if (driver) {
        this.driver = driver;
      }
    }
    if (this.eventData?.VI) {
      const vehicle = this.newDataStoreService.getVehicleById(this.eventData?.VI);
      if (vehicle) {
        this.vehicle = vehicle;
      }
    }
  }

  private getFuelData(): void {
    if (this.eventData?.ED && this.eventData.ED.V) {
      this.valueLFuel = Math.abs(this.eventData.ED.V);
      if (this.eventData.ED.IV) {
          // this.invoiceDiff = Math.abs(this.eventData.ED.V) - Math.abs(this.eventData.ED.IV);
      }
    }
  }

}
